import React, {Component} from 'react'
import userHelper from "../../helpers/user";

export default class PricingData extends Component {
    constructor(props) {
        super()
        this.state = {
            balanceInfo: props.balanceInfo,
            profile: props.profile
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            balanceInfo: nextProps.balanceInfo,
            profile: nextProps.profile
        })
    }

    render() {
        if (!Object.keys(this.state.balanceInfo).length) return null
        return (
            <section id='personal-data'>
                <ul className='no-ul-style'>
                    {this.state.balanceInfo.showBalance ? <li><b> Rendelkezésre álló egyenleg: {this.state.balanceInfo.balance} Ft </b></li> : null}
                    {userHelper.isTestMode() ? <li><b> Teszt üzemmód: {userHelper.testModeExpiration()}</b></li> : null}

                    {userHelper.hasModule('customer') ? <li> Az egyenleg a <b>következő számú tétel </b> kontírozására elegendő a <b>Vevő modulban: {this.state.balanceInfo.bankrowcredit} db </b></li> : null}
                    {userHelper.hasModule('bank') ? <li> Az egyenleg a <b>következő számú tétel </b> kontírozására elegendő a <b>Bank modulban: {this.state.balanceInfo.customerrowcredit} db </b></li> : null}
                    {userHelper.hasModule('supplier') ? <li> Az egyenleg a <b>következő számú tétel </b> kontírozására elegendő a <b>Szállító modulban: {this.state.balanceInfo.supplierrowcredit} db </b></li> : null}
                    {userHelper.hasModule('cashregister') ? <li> Az egyenleg a <b>következő számú 1 havi pénztárgép adat</b> kontírozására elegendő a <b>Pénztárgép modulban: {this.state.balanceInfo.cashregisterrowcredit} db </b></li> : null}
                    <li>
                        <hr/>
                    </li>
                    {userHelper.hasModule('customer') ? <li><b> Vevő modulban</b> egy tétel kontírozásának egységára (ár 27% ÁFÁ-t tartalmaz): <b>{this.state.balanceInfo.customerUnitPrice} Ft</b></li> : null}
                    {userHelper.hasModule('bank') ? <li><b>Bank modulban</b> egy tétel kontírozásának egységára (ár 27% ÁFÁ-t tartalmaz): <b>{this.state.balanceInfo.bankUnitPrice} Ft</b></li> : null}
                    {userHelper.hasModule('supplier') ? <li><b>Szállító modulban</b> egy tétel kontírozásának egységára (ár 27% ÁFÁ-t tartalmaz): <b>{this.state.balanceInfo.supplierUnitPrice} Ft</b></li> : null}
                    {userHelper.hasModule('cashregister') ? <li><b>Pénztár modulban</b> egy pénztárgép egy havi adatainak kontírozásának ára (ár 27% ÁFÁ-t tartalmaz): <b>{this.state.balanceInfo.cashRegisterUnitPrice} Ft</b></li> : null}
                </ul>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/profile/pricingdata.js